// Shortlist + recently-viewed vehicles, stored in localStorage (no login needed).
// Components listen for the 'bst-collections' event to stay in sync.
import { trackEvent } from './analytics';

const SHORTLIST_KEY = 'bst_shortlist';
const RECENT_KEY = 'bst_recently_viewed';
const RECENT_MAX = 8;

const read = (key) => {
  try {
    const raw = localStorage.getItem(key);
    const val = raw ? JSON.parse(raw) : [];
    return Array.isArray(val) ? val : [];
  } catch {
    return [];
  }
};

const write = (key, val) => {
  try {
    localStorage.setItem(key, JSON.stringify(val));
    window.dispatchEvent(new Event('bst-collections'));
  } catch {
    // storage full / private mode — degrade silently
  }
};

// Keep only the fields the card needs so stored entries stay small and
// stale price/status data ages out naturally as entries are re-saved.
const snapshot = (v) => ({
  id: v.id,
  title: v.title,
  brand: v.brand,
  model: v.model,
  year: v.year,
  km_run: v.km_run,
  city: v.city,
  price_final: v.price_final,
  badge_type: v.badge_type,
  status: v.status,
  images: v.images?.length ? [v.images[0]] : [],
  saved_at: Date.now(),
});

export const getShortlist = () => read(SHORTLIST_KEY);

export const isShortlisted = (id) => getShortlist().some((v) => v.id === id);

export const toggleShortlist = (vehicle) => {
  const list = getShortlist();
  const adding = !list.some((v) => v.id === vehicle.id);
  const next = adding
    ? [snapshot(vehicle), ...list]
    : list.filter((v) => v.id !== vehicle.id);
  write(SHORTLIST_KEY, next);
  trackEvent(adding ? 'shortlist_add' : 'shortlist_remove', {
    vehicle_id: vehicle.id,
    vehicle_title: vehicle.title,
  });
  return adding;
};

export const getRecentlyViewed = (excludeId) =>
  read(RECENT_KEY).filter((v) => v.id !== excludeId);

export const addRecentlyViewed = (vehicle) => {
  const list = read(RECENT_KEY).filter((v) => v.id !== vehicle.id);
  write(RECENT_KEY, [snapshot(vehicle), ...list].slice(0, RECENT_MAX));
};
